// extracted by mini-css-extract-plugin
export default {"cancelBtn":"TableHeader_cancelBtn__a6wa-","applyBtn":"TableHeader_applyBtn__bwyH7","buttonCont":"TableHeader_buttonCont__5ii9b"};